'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.once = once;
exports.on = on;
exports.off = off;
exports.isKeyboard = isKeyboard;
exports.createEventBinding = createEventBinding;

var _context = require('../util/context');

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function once(el, type, callback) {
  var typeArray = type ? type.split(' ') : [];
  var recursiveFunction = function recursiveFunction(event) {
    event.target.removeEventListener(event.type, recursiveFunction);
    return callback(event);
  };

  for (var i = typeArray.length - 1; i >= 0; i--) {
    this.on(el, typeArray[i], recursiveFunction);
  }
}

function on(el, type, callback, options) {
  if (el.addEventListener) {
    el.addEventListener(type, callback, options);
  } else {
    // IE8+ Support
    el.attachEvent('on' + type, callback);
  }
}

function off(el, type, callback, options) {
  if (el.removeEventListener) {
    el.removeEventListener(type, callback, options);
  } else {
    // IE8+ Support
    el.detachEvent('on' + type, callback);
  }
}

function isKeyboard(event) {
  return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
}

function createEventBinding() {
  for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }

  return function () {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _context2['default'].document;
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var options = arguments[2];

    names.forEach(function (event) {
      return on(el, event, cb, options);
    });
    return function () {
      return names.forEach(function (event) {
        return off(el, event, cb, options);
      });
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/util/events.js
// module id = 1821
// module chunks = 32